export enum Icon {
    ChevronRight = 'chevron-right',
    ChevronLeft = 'chevron-left'
}
